import React from 'react';
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import Service from '../../config/networkutils';
import Auth from '../../utils/authenticate';
import { Autocomplete } from '@material-ui/lab';
import AddIcon from '@material-ui/icons/Add';
import { getDataIsdeletedFalse } from '../Helper/CommonThings';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const token = Auth.token()

class ManageHR extends React.Component {
    constructor() {
        super()
        this.state = {
            data: [],
            isLoading: false,
            searchText: '',
            filters: {
                full_name: '',
                email: '',
                is_active: ''
            },
            detailPanelRows: {},
            openAddUserDialog: false,
            dialogMode: 'add',
            editingRowId: null,
            buData: [],
            postData: {
                user: null,
                business_unit: null,
                create_user: false,
                manage_access: false,
                activate_user: false
            },
            userData: []
        }
    }

    componentDidMount() {
        this.fetchBusinessUnit()
        this.fetchOps()
        this.fetchUserData()
    }

    fetchBusinessUnit = () => {
        Service.get('/api/business/unit/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ buData: resData })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    fetchUserData(){
        Service.get(`/api/users`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ userData: resData, isLoading: false })
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false })
            });
    }


    fetchOps() {
        this.setState({ isLoading: true })
        // /api/users
        Service.get(`/api/manage/business/unit/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ data: resData, isLoading: false })
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false })
            });
    }

    getDefaultPostData = () => ({
        user: null,
        business_unit: null,
        create_user: false,
        manage_access: false,
        activate_user: false
    })

    openAddDialog = () => {
        this.setState({
            openAddUserDialog: true,
            dialogMode: 'add',
            editingRowId: null,
            postData: this.getDefaultPostData()
        })
    }

    openEditDialog = (row) => {
        if (!row || !row.id) {
            this.props.enqueueSnackbar('Unable to edit this record', {
                variant: 'warning'
            });
            return;
        }

        const selectedUser = this.state.userData.find((item) =>
            (row.user && item.id === row.user) ||
            (row.user_id && item.id === row.user_id) ||
            (item.first_name === row.user_first_name && item.last_name === row.user_last_name)
        ) || null;

        const selectedBusinessUnit = this.state.buData.find((item) =>
            (row.business_unit && item.id === row.business_unit) ||
            (row.business_unit_id && item.id === row.business_unit_id) ||
            (row.bu_id && item.id === row.bu_id) ||
            item.name === row.bu_name
        ) || null;

        this.setState({
            openAddUserDialog: true,
            dialogMode: 'edit',
            editingRowId: row.id,
            postData: {
                user: selectedUser,
                business_unit: selectedBusinessUnit,
                create_user: !!row.create_user,
                manage_access: !!row.manage_access,
                activate_user: !!row.activate_user
            }
        })
    }

    closeDialog = () => {
        this.setState({
            openAddUserDialog: false,
            dialogMode: 'add',
            editingRowId: null,
            postData: this.getDefaultPostData()
        })
    }

    putOps(data) {
        this.setState({ isLoading: true })
        Service.put("/api/request/password/" + data.email + "/?email=" + data.email, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res1 => {
                this.setState({ isLoading: false });
                this.props.enqueueSnackbar('Access updated for ' + data.email, {
                    variant: 'success',
                });
                this.fetchOps();
            })
            .catch(error => {
                this.setState({ isLoading: false });
                // console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    deleteOps = (row) => {
        if (!row || !row.id) {
            this.props.enqueueSnackbar('Unable to delete this record', {
                variant: 'warning'
            });
            return;
        }


        this.setState({ isLoading: true });
        Service.delete(`/api/manage/business/unit/${row.id}/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(() => {
                this.setState({ isLoading: false });
                this.props.enqueueSnackbar('Access deleted successfully', {
                    variant: 'success'
                });
                this.fetchOps();
            })
            .catch(() => {
                this.setState({ isLoading: false });
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    handleSearchChange = (event) => {
        this.setState({ searchText: event.target.value })
    }

    handleFilterChange = (field, value) => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                [field]: value
            }
        }))
    }

    toggleDetailPanelRow = (rowId) => {
        this.setState((prevState) => ({
            detailPanelRows: {
                ...prevState.detailPanelRows,
                [rowId]: !prevState.detailPanelRows[rowId]
            }
        }))
    }

    addUser() {
        const { user, business_unit, create_user, manage_access, activate_user } = this.state.postData;
        if (!user || !business_unit) {
            this.props.enqueueSnackbar('Please select user and business unit', {
                variant: 'warning'
            });
            return;
        }
        // Add user logic here
        const data = {
            user: user.id,
            business_unit: business_unit.id,
            create_user: create_user,
            manage_access: manage_access,
            activate_user: activate_user
        };
        this.setState({ isLoading: true });
        Service.post('/api/manage/business/unit/link_manage_business_unit_users/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res1 => {
                this.setState({ isLoading: false });
               this.props.enqueueSnackbar('User added successfully', {
                    variant: 'success',
                });
                this.closeDialog();
                this.fetchOps();
            })
            .catch(error => {
                this.setState({ isLoading: false });
                // console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });

    }

    editUser = () => {
        const { user, business_unit, create_user, manage_access, activate_user } = this.state.postData;
        if (!user || !business_unit) {
            this.props.enqueueSnackbar('Please select user and business unit', {
                variant: 'warning'
            });
            return;
        }

        if (!this.state.editingRowId) {
            this.props.enqueueSnackbar('Unable to update this record', {
                variant: 'warning'
            });
            return;
        }

        const data = {
            user: user.id,
            id: this.state.editingRowId,
            user_first_name: user.first_name,
            user_last_name: user.last_name,
            business_unit: business_unit.id,
            bu_name: business_unit.name,
            create_user: create_user,
            manage_access: manage_access,
            activate_user: activate_user
        };

        this.setState({ isLoading: true });
        Service.patch(`/api/manage/business/unit/update_manage_business_unit_users/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(() => {
                this.setState({ isLoading: false });
                this.props.enqueueSnackbar('User access updated successfully', {
                    variant: 'success',
                });
                this.closeDialog();
                this.fetchOps();
            })
            .catch(() => {
                this.setState({ isLoading: false });
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    submitDialog = () => {
        if (this.state.dialogMode === 'edit') {
            this.editUser();
            return;
        }
        this.addUser();
    }

    render() {
        const filteredData = this.state.data.filter((row) => {
            const fullName = `${row.user_first_name || ''} ${row.user_last_name || ''}`.trim().toLowerCase()
            const businessUnit = (row.bu_name || '').toLowerCase()
            const activeStatus = row.is_active ? 'active' : 'inactive'
            const searchText = (this.state.searchText || '').toLowerCase()

            const matchesSearch = searchText === '' || fullName.includes(searchText) || businessUnit.includes(searchText) || activeStatus.includes(searchText)
            const matchesNameFilter = fullName.includes((this.state.filters.full_name || '').toLowerCase())
            const matchesBusinessUnitFilter = businessUnit.includes((this.state.filters.business_unit || '').toLowerCase())
            const matchesStatusFilter = this.state.filters.is_active === '' || activeStatus === this.state.filters.is_active

            return matchesSearch && matchesNameFilter && matchesBusinessUnitFilter && matchesStatusFilter
        })

        return (
            <>
                {this.state.isLoading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'><CircularProgress /></Box> :
                    <TableContainer component={Paper} style={{ marginTop: 24 }}>
                        <Box display='flex' alignItems='center' justifyContent='space-between' p={2} pb={1}>
                            <Box display='flex'>
                                <Typography variant="h6" style={{ padding: 16 }}>Business Unit Admin</Typography>
                            </Box>
                            <Box display='flex' alignItems='center' gap={2}>
                                <Box display="flex" justifyContent="flex-end" p={2} pb={1}>
                                    <TextField
                                        label="Search"
                                        placeholder="Search"
                                        variant="outlined"
                                        size="small"
                                        value={this.state.searchText}
                                        onChange={this.handleSearchChange}
                                    />
                                </Box>
                                <Tooltip title="Add User">
                                    <IconButton onClick={this.openAddDialog}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold' }}>User</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Business Unit</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Create User</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Manage Access</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Activate User</TableCell>
                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Actions</TableCell>
                                    {/* <TableCell align="right" style={{ fontWeight: 'bold' }}>Actions</TableCell> */}
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            value={this.state.filters.full_name}
                                            onChange={(event) => this.handleFilterChange('full_name', event.target.value)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            value={this.state.filters.email}
                                            onChange={(event) => this.handleFilterChange('email', event.target.value)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            select
                                            value={this.state.filters.is_active}
                                            onChange={(event) => this.handleFilterChange('create_user', event.target.value)}
                                        >
                                    </TableCell>
                                    <TableCell />
                                </TableRow> */}
                            </TableHead>
                            <TableBody>
                                {filteredData.length > 0 ? filteredData.map((row) => {
                                    const rowId = row.id || row.email

                                    return (
                                        <React.Fragment key={rowId}>
                                            <TableRow hover>
                                                <TableCell>{row.user_first_name + ' ' + row.user_last_name}</TableCell>
                                                <TableCell>{row.bu_name}</TableCell>
                                                <TableCell>{row.create_user ? <CheckIcon/> : <RemoveIcon/>}</TableCell>
                                                <TableCell>{row.manage_access ? <CheckIcon/> : <RemoveIcon/>}</TableCell>
                                                <TableCell>{row.activate_user ? <CheckIcon/> : <RemoveIcon/>}</TableCell>
                                                <TableCell align="center">
                                                    <Tooltip title="Edit">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.openEditDialog(row)}
                                                        >
                                                            <EditOutlinedIcon style={{ color: '#1976d2' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.deleteOps(row)}
                                                        >
                                                            <DeleteOutlineIcon style={{ color: '#d32f2f' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                                {/* <TableCell align="right">
                                                    <IconButton
                                                        title={row.is_hr === true ? 'Accessible' : 'Grant Access'}
                                                        onClick={() => this.putOps({ ...row, is_hr: true })}
                                                        disabled={row.is_hr === true}
                                                    >
                                                        <CheckCircleOutline style={{ color: row.is_hr === true ? '#4CAF50' : '#9E9E9E' }} />
                                                    </IconButton>
                                                    <IconButton
                                                        title={row.is_hr === true ? 'Revoke Access' : 'Unaccessible'}
                                                        onClick={() => this.putOps({ ...row, is_hr: false })}
                                                        disabled={row.is_hr === false}
                                                    >
                                                        <HighlightOff style={{ color: row.is_hr === false ? '#F44336' : '#9E9E9E' }} />
                                                    </IconButton>
                                                </TableCell> */}
                                            </TableRow>
                                        </React.Fragment>
                                    )
                                }) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>}
                <Dialog open={this.state.openAddUserDialog} onClose={this.closeDialog} maxWidth="sm" fullWidth>
                    <DialogTitle>{this.state.dialogMode === 'edit' ? 'Edit User Access' : 'Add User'}</DialogTitle>
                    <DialogContent>
                        <Box marginTop={2}>
                            <Autocomplete
                                value={this.state.postData.user}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        this.setState({ postData: { ...this.state.postData, user: newValue } })
                                    } else {
                                        this.setState({ postData: { ...this.state.postData, user: null } })
                                    }
                                }}
                                options={this.state.userData}
                                getOptionLabel={(option) => option.first_name + ' ' + option.last_name || ''}
                                renderInput={(params) => <TextField {...params} label="Select User" variant="outlined" fullWidth />}
                            />
                        </Box>
                        <Box marginTop={2}>
                            <Autocomplete
                                value={this.state.postData.business_unit}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        this.setState({ postData: { ...this.state.postData, business_unit: newValue } })
                                    } else {
                                        this.setState({ postData: { ...this.state.postData, business_unit: null } })
                                    }
                                }}
                                options={this.state.buData}
                                getOptionLabel={(option) => option.name || ''}
                                renderInput={(params) => <TextField {...params} label="Select Business Unit" variant="outlined" fullWidth />}
                            />
                        </Box>
                        <Box marginTop={2}>
                            <Box display='flex' flexDirection='row' justifyContent='space-between' gap={2}>
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.postData.create_user} onChange={(event) => this.setState({ postData: { ...this.state.postData, create_user: event.target.checked } })} />}
                                    label="Add User"
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.postData.manage_access} onChange={(event) => this.setState({ postData: { ...this.state.postData, manage_access: event.target.checked } })} />}
                                    label="Manage Access"
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.postData.activate_user} onChange={(event) => this.setState({ postData: { ...this.state.postData, activate_user: event.target.checked } })} />}
                                    label="Activate User"
                                />
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='primary' onClick={this.closeDialog} >
                            Cancel
                        </Button>
                        <Button variant='contained' color='primary' onClick={this.submitDialog} >
                            {this.state.dialogMode === 'edit' ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

}

export default withSnackbar(ManageHR);
